import { render, staticRenderFns } from "./EDIOrders.vue?vue&type=template&id=4fd6a1d9&scoped=true&"
import script from "./EDIOrders.vue?vue&type=script&lang=js&"
export * from "./EDIOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd6a1d9",
  null
  
)

export default component.exports